﻿/**
 * Global Ultility Snippets
 *
 *
 * @class rlGlobal
 * @memberOf jQuery.fn
 */

(function ($) {
    //detect if page is running with large font-size base.
    function detectFontSizeBase() {
       const htmlBase = $('html'),
       veryLarge = 'veryLargeFontBase'
       let baseFont = htmlBase.css('font-size');
       baseFont = baseFont.replace('px', '');

       if (htmlBase.attr('data-basefontsize') != baseFont) {
          htmlBase.attr('data-basefontsize', baseFont);
       }

       var basefontsizeClass = htmlBase.attr('data-basefontsize') >= 20 ? htmlBase.addClass(veryLarge) : htmlBase.removeClass(veryLarge);
       basefontsizeClass;
    }
    detectFontSizeBase();

    // Removes empty p tags that tiny MCE adds for some reason
    $('p:empty').remove();

    //JavaScript window resize event with a 150ms delay
    $(function() {
        var resizeEnd;
        $(window).on('resize', function() {
            clearTimeout(resizeEnd);
            resizeEnd = setTimeout(function() {
                $(window).trigger('resize-end');
            }, 150);
        });
    });
    /*sample use case
    $(window).on('resize-end', function () {
        //your code here
    });*/

    //detect if standardPage li tags have ul or ol children
    //if true adds a class (nopadding) that eliminates padding
    $("#main-content .standardPage li, #main-content .sitemapPage li, #main-content .homePage li").each(function() {
        if ($(this).children("ul").length) {
            $(this).addClass("nopadding");
        } else if ($(this).children("ol").length) {
            $(this).addClass("nopadding");
        }
    });

    //Truncate text function use .trimToLength(xx); - XX is number of chars value
    String.prototype.trimToLength = function(m) {
        return (this.length > m) ?
            jQuery.trim(this).substring(0, m).split(" ").slice(0, -1).join(" ") + "..." :
            this;
    };
    
    //switch <b> tags with <strong>
    $('#main-content b').replaceWith(function() {
        return $('<strong>').append($(this).html())
    });
    //switch <i> tags with <em>
    $('#main-content i').replaceWith(function() {
        return $('<em>').append($(this).html())
    });
    
    //Set SVG on blockquote tags
    const BlockQuote = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.73 30" class="blockquote" focusable="false"><path d="M20.58,18.05V30H34.85V16h-7A11.3,11.3,0,0,1,35.36,5.61V0C25.68,2.11,20.58,8.32,20.58,18.05" transform="translate(-0.64)"/><path d="M.64,18.05V30H14.91V16h-7A11.28,11.28,0,0,1,15.42,5.61V0C5.73,2.11.64,8.32.64,18.05" transform="translate(-0.64)"/></svg>';
    $('#main-content blockquote').prepend(BlockQuote);
    
    $.fn.isAfter = function(sel) {
        return this.prevAll().filter(sel).length !== 0;
    };
    
    //detect if comparison block comes after a rich text block and remove margin
    if ($(".comparisoncontainerblock").isAfter(".richtextblock")) {
        $("#main-content .container .richtextblock").css('margin-bottom', 0);
    }

    //detect if feefo floating widget block is used and remove bottom margin form that block as element is pos:fixed
    if ($('.feefodatablock').find('#feefo-service-review-floating-widgetId').length) {
        $('#feefo-service-review-floating-widgetId').parent().css('margin-bottom', 0);
    }

    //tooltip activation
    $(function() {
        $('[data-toggle="tooltip"]').tooltip({
                animated: 'fade',
                trigger: 'hover'
            })
        //hide tooltip on swipe
        $('.comp-slider').on('swipe', function(event, slick, direction) {
            $('.tooltip-help.option-tooltip').tooltip('hide');
        });
    });

    //detect if html height is less than window height (bug: 300214)
    function viewport_height() {
       const html = $('html.yourplan'),
          header = $('header'),
          footer = $('footer'),
          maincontent = $('.main-content');

       maincontent.removeAttr('style');

       const window_height = window.innerHeight,
          html_height = html.innerHeight(),
          header_height = header.outerHeight(true),
          footer_height = footer.outerHeight(true),
          minMainContent = window_height - (header_height + footer_height);

       if (html_height < window_height && html.length > 0) {
          maincontent.css('min-height', minMainContent);
       }
    }

    //detect if image is landscape or portrait
    var imagelist = $('.AuthorProfile--headshot img, .header__site-logo-additional img');
    if (imagelist.width() > imagelist.height()) {
        imagelist.addClass('landscape');
    }
    else if (imagelist.width() < imagelist.height()) {
        imagelist.addClass('portrait');
    }
    else {
        imagelist.addClass('square');
    }

    //footer column titles (apply subsitutes if field is blank)
    $(".footer__links-list .title h5").each(function() {
        var h5text = $(this).text(),
            h5subtitle = $(this).data('column');

        if (h5text === '' || h5text === null || h5text === 'undefined') {
            $(this).text(h5subtitle);
        }
    });
     
    //footer empty container checker
    if ($('.footer__social-media-links ul li').length === 0) {
       $('.footer__social-media-links').addClass('empty').attr('aria-hidden', 'true');
       $('.footer__social-media-links').parent('div').addClass('empty');
    }
    if ($('.footer__feature-panel').length === 0) {
       $('.footer__promo-and-social').children('.no-gutters').addClass('empty').attr('aria-hidden', 'true');
    }
    if ($('.footer__social-media-links ul li').length === 0 && $('.footer__feature-panel').length === 0) {
       $('.footer__promo-and-social').addClass('bothempty');
       $('.footer__promo-and-social').children('.no-gutters').addClass('both');
       $('.footer__social-media-links').parent('div').addClass('both');
    }
    if ($('.footer__links-list > div').length === 0) {
       $('.footer__links-list').addClass('empty').attr('aria-hidden', 'true');
    }
    if ($('.footer__promo-and-social').hasClass('bothempty') && $('html.yourplan .footer__links-list').hasClass('empty')) {
       $('.footer__regulatory').addClass('standalone');
    }
    if ($('.footer__regulatory ul.nav').children('li').length === 0) {
       $('.footer__regulatory ul.nav').remove();
    }

    //footer social media icons
    function socialmediaiconssize() {
        const socialul = $(".footer__social-media-links ul"),
            socialli = $(".footer__social-media-links ul li"),
            iconwidth = socialli.children('a').innerWidth(),
            iconheight = Math.round(iconwidth),
            bootstrap_md_min = 768;

        //negative margin layout fixer
        socialli.css('height', iconheight);

        if ($(window).width() >= bootstrap_md_min) {
            const footerpadding = 30,
                  iconsize = iconwidth / 2;
                  negmargin = footerpadding + iconsize,
                  negmargintrue = Math.round(negmargin)

            $('.footer__social-media-links').css('margin-top', -negmargintrue);
        }
        else {
            $('.footer__social-media-links').removeAttr('style');
        }

        //icon count & layout change in desktop if 5 or more
        if (socialli.length >= 5) {
            socialul.addClass('justified-xl');
        }

    }
    $(window).on('resize-end', function () {
       socialmediaiconssize();
       viewport_height();
    });
    socialmediaiconssize();
    viewport_height();
    

    //hastag on the end of a url defect fix (bug: 231257)
    var currenturl = window.location.href,
        urllength = location.href.length - 1,
        lastindexhash = window.location.href.lastIndexOf("#");

    if (lastindexhash === urllength) {
        currenturl = currenturl.substring(0, currenturl.length - 1);
        history.pushState({}, null, currenturl);
    }

    //list of block and link items we want to control via the spacebar
    var spacebarlinks = $('.fb-nav-item, .search-bar__input, .FormFileUpload__Input, .Form__Element select, .nav-item.level1 .nav-link.level1, .navbar-nav.level2 .nav-link, .navbar-nav.level2 .cta-button, .header__top-navigation .nav-link, .cta-button, .header__site-logo a, .cta, button.close, .no-underline, .cta-button-arrow, .nav-link, ol.breadcrumb a, .telnumber a, .footer__social-links a, .footer__links-list a, .footer__regulatory a, .featurebanner-content a, .accordion-link, .richtextcontainerblock a, .sliderblock a, .accordion-intro a, .accordion-item a, .multiassetcontainerblock a, .manualtileblock a, .autotileblock a, .campaignblock a, .filterresults a');

    spacebarlinks.on('focusin', function (e) {

        var attr = $(this).attr('href'),
            currentclassname = $(this).attr('class'),
            currentid = $(this).attr('id');

        if (typeof attr !== typeof undefined && attr !== false) {
            var thisurl = $(this).attr('href');
        } else {
            var thisurl = '';
        }

        var target = e.target;

        window.onkeydown = function (event) {

            if (event.keyCode === 32 && target === document.activeElement) {

                if (thisurl !== null && thisurl !== '') {
                    event.preventDefault();
                    window.location.href = thisurl;
                }
                //Accordian
                if (currentclassname == "collapsed accordion-link" || currentclassname == "accordion-link collapsed") {
                    event.preventDefault();
                    $('#' + currentid).removeClass('collapsed');
                    $('#' + currentid).data('expanded', 'true');
                    $('#' + currentid).next('.accordion-item-body').addClass('show');

                    currentclassname = 'accordion-link';
                }
                else if (currentclassname == "accordion-link") {
                    event.preventDefault();

                    $('#' + currentid).addClass('collapsed').focus();
                    $('#' + currentid).data('expanded', 'false');
                    $('#' + currentid).next('.accordion-item-body').removeClass('show');

                    if ($(window).width() <= 767.98) {
                        var headerHeight = 80;
                    } else if ($(window).width() <= 991.98) {
                        var headerHeight = 110;
                    } else {
                        var headerHeight = 90;
                    }

                    $('html, body').stop().animate({
                        'scrollTop': $('#' + currentid).offset().top - headerHeight
                    }, 200, 'swing');
                }
            }
        };
    });


    ///Checks that the correct theme is used when sibling block are used within themed parent blocks. 
    function themeCorrector(el) {
      $(el).each(function () {
         if ($(this).parents().hasClass('royal-purple')) {
            $(this).removeClass("royal-white").addClass('royal-purple').addClass('no-before-or-after');
         }
      });
    }
    themeCorrector(".richtextblock .richtextblock-content");
    themeCorrector(".accordionlightblock .accordion-block");
    themeCorrector(".accordionblock .accordion-block");
    themeCorrector(".formcontainerblock .FormParagraphText");
    function richtextThemeCorrector(el) {
       $(el).each(function () {
          if ($(this).find('.rich-text-wrapper').hasClass('royal-purple')) {
             $(this).addClass('purpletheme');
          }
          else if ($(this).find('.rich-text-wrapper').hasClass('royal-neutral')) {
             $(this).addClass('neutraltheme');
          }
       });
    }
    richtextThemeCorrector(".richtextcontainerblock");

    // Focus previous element when shift + tab pressed
    $('h1').on('keydown blur', function (e) {
        if (e.which === 9 && e.shiftKey) {
            $('.skiptocontent').focus();
        }
    });

    // Back to top - return/spacebar key function
    $('.backtotop')
        .on('click', function (e) {
            smoothScroll(e, 800);
        })
        .on('keypress', function (e) {
            if (e.keyCode === 32) {
                smoothScroll(e, 800);
            }
        });

    // Skip to content - return/spacebar key function
    $('.skiptocontent')
        .on('click', function (e) {
            smoothScroll(e, 200);
        })
        .on('keypress', function (e) {
            if (e.keyCode === 32) {
                smoothScroll(e, 200);
            }
        });

    function smoothScroll(e, timing) {
        e.preventDefault();
        // Using jQuery's animate() method to keep the scroll top
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').stop().animate({ 'scrollTop': 0 }, timing, function () {

           if ($('.yourplan #YPwelcometitle').length > 0) {
              $('#YPwelcometitle h1').prop('tabindex', '-1').focus();
           }
           else {
              // Set focus to the first h1 of the page
              $('#main-content h1:first').prop('tabindex', '-1').focus();
           }
            
        });
   }

   //RL's custom matchheight function - used to retrigger matchheight components & detect font-size base.
   var rlMatchHeight;
   rlMatchHeight = (function () {
      let stateCheck = setInterval(() => {
         if (document.readyState === 'complete') {
            clearInterval(stateCheck);

            elem = document.getElementById("main-content");
            let resizeObserver = new ResizeObserver(() => {
               $.fn.matchHeight._update();
               detectFontSizeBase();
            });
            resizeObserver.observe(elem);
         }
      }, 250);
   });
   rlMatchHeight();

}(jQuery));